<ng-container *ngIf="!isButton; else buttonTemplate">
  <ul class="list-group {{ flush }}">
    <li
      *ngFor="let item of listItems"
      class="list-group-item d-flex justify-content-between align-items-center"
    >
      {{ item[itemLabel] }}
      <app-badge
        [size]="badgeSize"
        [type]="badgeType"
        [color]="badgeColor"
        [light]="badgeLight"
        [text]="item[itemBadge]"
      ></app-badge>
      <ng-content select="[itemBadge]"></ng-content>

    </li>
  </ul>
</ng-container>

<ng-template #buttonTemplate>
  <div class="list-group">
    <div
      *ngFor="let item of listItems"
      style="cursor: pointer"
      class="list-group-item list-group-item-action flex-column align-items-start {{
        listItemStyle
      }} "
      [class.active]="item.isActive"
      (click)="itemClicked(item)" role="button"  tabindex="-1"
    >
      {{ item[itemLabel] }}
      <div *ngIf="itemHeader" class="d-flex w-100 justify-content-between">
        <h5 class="mb-3">{{ item[itemHeader] }}</h5>
        <small> {{ item[itemDate] }}</small>
      </div>
      <p class="mb-1">
        {{ item[itemContent] }}
      </p>
      <small> {{ item[itemSum] }}</small>
    </div>
  </div>
</ng-template>
